// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__3Il3A","small":"page_small__1kvGP","large":"page_large__6FMgs","hasHeader":"page_hasHeader__2x7qp"};